export enum ContainerType {
  BORDERED = 'bordered',
  BORDERED_WITH_SHADOW = 'bordered-with-shadow',
  INFO = 'info',
  INFO_SECONDARY = 'info-secondary',
  LIST = 'list',
  POPOVER = 'popover',
  PRIMARY = 'primary',
}
